import {
  NavLink,
  Outlet,
  useOutletContext,
  useLocation,
} from 'react-router-dom';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../../../../context/LanguageContext';
import { normalizeSupportedLanguage } from '../../../../utils/createScopedI18n';
import { dataManagementI18n } from './i18n';
import './dataManagement.scss';

export default function DataManagement() {
  const { language } = useLanguage();
  const dataManagementLanguage = normalizeSupportedLanguage(language);
  const { t } = useTranslation(undefined, { i18n: dataManagementI18n });

  const { DesignSystemComponents } = useOutletContext() ?? {};
  const { Card } = DesignSystemComponents ?? {};
  const location = useLocation();

  useEffect(() => {
    dataManagementI18n.changeLanguage(dataManagementLanguage);
  }, [dataManagementLanguage]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [location.pathname]);

  if (!Card) return null;

  const tabs = [
    { to: 'tribunales', label: t('data_management_tab_courts') },
    { to: 'negocios', label: t('data_management_tab_business_lines') },
    { to: 'servicios', label: t('data_management_tab_services') },
    { to: 'tareas', label: t('data_management_tab_tasks') },
    { to: 'areas', label: t('data_management_tab_areas') },
    {
      to: 'excluidos',
      label: t('data_management_tab_excluded_plaintiffs'),
    },
  ];

  return (
    <Card specialPadding='p-4'>
      <div className='d-flex justify-content-between align-items-start mb-3'>
        <div>
          <h2 className='mb-1'>{t('data_management_title')}</h2>
          <p className='caption font-light'>{t('data_management_subtitle')}</p>
        </div>
      </div>

      <nav
        role='tablist'
        aria-label={t('data_management_tabs_aria_label')}
        className='mb-3 border-bottom'
      >
        {tabs.map((tab) => (
          <NavLink
            key={tab.to}
            to={tab.to}
            role='tab'
            className={({ isActive }) =>
              `navbar-item ${isActive ? 'isActive' : ''}`
            }
            end
          >
            {({ isActive }) => (
              <span aria-current={isActive ? 'page' : undefined}>
                {tab.label}
              </span>
            )}
          </NavLink>
        ))}
      </nav>

      <Outlet context={{ DesignSystemComponents }} />
    </Card>
  );
}
